import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { message, Space, Form as FormInitial, Row, Col } from "antd";
import {
  DownloadOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import alumnosGrupoPdf from "../../../../Pdf/alumnosGrupoPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class AlumnosGrupoModal extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
    grupo: null,
    alumnos: [],
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.visible !== this.props.visible &&
      this.props.visible &&
      this.props.grupoEscuelaId
    ) {
      this.consultarTodo();
    }
  }

  consultarTodo = async () => {
    this.setState({ loading: true, pdf: null, grupo: null, alumnos: [] });
    try {
      const res = await axios.post(
        "gruposEscuela/alumnosDeGrupoEscuela",
        {
          grupoEscuelaId: this.props.grupoEscuelaId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken },
      );

      if (res.data.success !== 2) {
        this.setState({ loading: false });
        message.error(res.data.message || "No se pudieron cargar los alumnos");
        return;
      }

      const grupo = res.data.grupo || null;
      const alumnos = res.data.alumnos || [];

      const pdf = pdfMake.createPdf(
        alumnosGrupoPdf({ grupo, alumnos, empresa: this.props.empresa }),
      );

      this.setState(
        { loading: false, grupo, alumnos, pdf },
        () => {
          // Abrir el PDF dentro del iframe del modal.
          if (window.frames["pdfAlumnosGrupo"]) {
            pdf.open({}, window.frames["pdfAlumnosGrupo"]);
          }
        },
      );
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
      message.error("Error al consultar los alumnos");
    }
  };

  cerrar = () => {
    this.setState({ pdf: null, grupo: null, alumnos: [] });
    if (this.formRef.current) this.formRef.current.resetFields();
    this.props.cerrarModal();
  };

  descargarPDF = () => {
    if (!this.state.pdf) return;
    const nombre = `Alumnos - ${this.state.grupo?.nombre || "grupo"}.pdf`;
    this.state.pdf.download(nombre);
  };

  onFinishFailed = (e) => ErrorItem(e);

  onFinish = (values) => {
    if (!values?.correosEnvio?.length) {
      message.info("Proporcione al menos un correo de envío");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "gruposEscuela/enviarListaAlumnos",
        {
          grupoEscuelaId: this.props.grupoEscuelaId,
          empresaId: this.props.empresaId,
          correosEnvio: values.correosEnvio,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Lista de alumnos enviada");
          if (this.formRef.current) this.formRef.current.resetFields();
          this.cerrar();
        } else if (res.data.success === 1) {
          message.error(
            res.data.message || "No se pudo enviar a los correos indicados",
          );
        } else {
          message.error("Sucedió un error y no se pudo enviar");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  };

  render() {
    const { grupo } = this.state;
    return (
      <ModalItem
        title={
          grupo
            ? `Alumnos de "${grupo.nombre}" — ${grupo.escuela?.nombre || ""}`
            : "Alumnos del grupo"
        }
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrar}
        paddingTop
        zIndex={this.props.zIndex}
      >
        <Form
          ref={this.formRef}
          name="enviarAlumnosGrupo"
          layout
          width={700}
          onCancel={this.cerrar}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: "" }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem
                          style={{ width: "100%" }}
                          placeholder="Correo"
                        />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: "center", marginTop: 5 }}>
                    <ButtonItem
                      type="primary"
                      className="botonAgregar"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>

          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            <Space>
              <ButtonItem
                icon={<DownloadOutlined />}
                blanco
                className="botonAgregar"
                disabled={!this.state.pdf}
                onClick={this.descargarPDF}
              >
                Descargar PDF
              </ButtonItem>
              <ButtonItem
                type="primary"
                htmlType="submit"
                className="botonAgregar"
                disabled={!this.state.pdf}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                className="botonAgregar"
                onClick={this.cerrar}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          title="Alumnos del grupo"
          style={{ width: "100%", height: "100vh" }}
          id="pdfAlumnosGrupo"
          name="pdfAlumnosGrupo"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
  empresa: state.empresa,
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(AlumnosGrupoModal);